
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/blacklives-matters",
      function () {
        return require("private-next-pages/blog/blacklives-matters.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/blacklives-matters"])
      });
    }
  